// removed by extract-text-webpack-plugin
module.exports = {"Booking":"App__Booking__qPCUX","PageTitle":"App__PageTitle__1xCzN","Title":"App__Title__2x147","SubTitle":"App__SubTitle__23W7K"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 14
// module chunks = 0